import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '../../../../../../../node_modules/@ngx-translate/core';
import { ConfirmationService } from '../../../../../vass-core/components/modal/confirmation.service';
import { CommonService } from '../../../../../vass-core/services/common.service';
import { UploadFileComponent } from '../../../../components/modals/upload-file/upload-file.component';
import { DocumentModel } from '../../../../models/documentation.model';
import { DocumentationService } from '../../../../services/documentation/documentation.service';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  standalone: false,
})
export class DocumentComponent implements OnInit {
  @Input() listDocuments: Array<DocumentModel>;
  @Input() name: string;
  @Input() filesNotType: boolean = false;

  constructor(
    private confirmationService: ConfirmationService,
    public translate: TranslateService,
    private _commonService: CommonService,
    private documentationService: DocumentationService,
  ) {}

  ngOnInit() {
    this.listDocuments.forEach((document) => {
      document['classContent'] = this.getClassContent(
        document.status,
        document.totalFiles,
      );
      document['icon'] = this.getIcon(document.status);
      document['text'] = this.getText(document.status, document.totalFiles);
    });
  }

  /**
   * Dependiendo del estado y del numero de ficheros asigna un estado
   */
  private getClassContent(status: string, numFiles: number) {
    switch (status) {
      case 'REVIEW_DOC_PENDING': {
        if (numFiles > 0) {
          return 'uploaded';
        }
        return '';
      }
      case 'REVIEW_DOC_ADMITTED':
        return 'valid';
      case 'REVIEW_DOC_OBSERVATION':
        return 'not-valid';
      default:
        return '';
    }
  }

  private getIcon(status: string) {
    switch (status) {
      case 'REVIEW_DOC_PENDING':
        return 'ic-doc-pending';
      case 'REVIEW_DOC_ADMITTED':
        return 'ic-check';
      case 'REVIEW_DOC_OBSERVATION':
        return 'ic-warning';
      default:
        return 'ic-doc-pending';
    }
  }

  private getText(status: string, numFiles: number) {
    switch (status) {
      case 'REVIEW_DOC_PENDING': {
        if (this.filesNotType) {
          return this.translate.instant('app_document_attach_document');
        } else if (numFiles === 1) {
          return `${numFiles} ${this.translate.instant('app_document_file')}`;
        }
        return `${numFiles} ${this.translate.instant('app_document_files')}`;
      }
      case 'REVIEW_DOC_ADMITTED':
        return this.translate.instant('app_document_validated_documentation');
      case 'REVIEW_DOC_OBSERVATION':
        return this.translate.instant('app_document_file_with_observations');
      default: {
        if (this.filesNotType) {
          return this.translate.instant('app_document_attach_document');
        } else if (numFiles === 1) {
          return `${numFiles} ${this.translate.instant('app_document_file')}`;
        }
        return `${numFiles} ${this.translate.instant('app_document_files')}`;
      }
    }
  }

  openModalUpload(document: DocumentModel) {
    const options: Object = {
      txtButton: '',
      showHeader: true,
      header: this.translate.instant('documentation.name_' + document.type),
      closeOnEscape: false,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
      maxWidth: 900,
      width: 900,
    };

    const data = {
      listDocuments: this.documentationService.listAllDocuments,
      category: document.category,
      type: document.type,
      holder: document.holder,
      filesNotType: this.filesNotType,
      canUpload: document.status !== 'REVIEW_DOC_ADMITTED',
    };

    this.confirmationService.confirm(<any>{
      component: UploadFileComponent,
      options,
      data: data,
      accept: (data) => {
        if (data) {
          if (data.action === 'add-file') {
            document.totalFiles = document.totalFiles + 1;
            this._commonService.sendNotification({
              key: 'save-document-ok',
              severity: 'success',
              position: 'top-center',
              summary: this.translate.instant('toast_component_send'),
              time: 5000,
              detail: this.translate.instant('toast_component_upload_success'),
            });
          } else if (data.action === 'delete-file') {
            document.totalFiles = document.totalFiles > 0 ? document.totalFiles - 1 : 0;
            this._commonService.sendNotification({
              key: 'delete-ok',
              severity: 'success',
              position: 'top-center',
              summary: this.translate.instant('app_document_toast_delete_file_title'),
              time: 5000,
              detail: this.translate.instant('app_document_toast_delete_file_msg'),
            });
          }
          document['classContent'] = this.getClassContent(
            document.status,
            document.totalFiles,
          );
          document['icon'] = this.getIcon(document.status);
          document['text'] = this.getText(document.status, document.totalFiles);
        }
      },
      reject: () => {},
    });
  }
}
